<template>
  <audio controls :class="{ admin: userType === 'admin' }">
    <source :src="filePath" type="audio/mpeg" />
  </audio>
</template>

<script>
export default {
  name: "ChatAudioPlayer",
  props: {
    filePath: {
      type: String,
      required: true
    },
    userType: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>
audio::-webkit-media-controls-panel {
  background-color: #b3fffd;
}

audio.admin::-webkit-media-controls-panel {
  background-color: #fff;
}
</style>
